import React from 'react';
import { ListItemIcon } from '@material-ui/core';
import PropTypes from 'prop-types';
import * as Icon from '@material-ui/icons';
import clsx from 'clsx';
import { defaultStyles } from 'utils/Theme';

const SelectionsIconButton = ({ handleClearSelections }) => {
    const classes = defaultStyles();
    return (
        <ListItemIcon
            style={{
                width: 30,
            }}
        >
            <Icon.HighlightOff
                className={clsx(classes.iconButton)}
                onClick={handleClearSelections}
            />
        </ListItemIcon>
    );
};
SelectionsIconButton.propTypes = {
    handleClearSelections: PropTypes.func.isRequired,
};

export default SelectionsIconButton;
